
import Vue from 'vue'
import router from '../../router'

const state = {
  // quando si seleziona la riparazione o dispositivo  scrivo direttament  dentro l oggetto  CHECKED : TRUE
  setPriceOf: null, //ricambio a cui modificare il prezzo quando settato mostra modal
  orderObj: {}, // l oggetto che andrò a salvare.Contiene tutte le info necesserie x l' ordine.
  cart: [],
  orderState: 'new',
  orderDettails: '',
  appliedList: '',
  localListData: [],
  deviceList: [],
  selectedDevice: '',
  selectedTab: '',
  selettore: '',
  checkOutMode: 0, // modalità checkout attiva
  showModal: false, // mostra modal
  infoDispositivoIndex: null, // mostra indoDispositivo, contiene l'indice del dispositivo, se null nasconde la finestra
  //STATI: 0 ATTESA RICAMBI, 1 IN RIPARAZIONE, 2 RIPARATO
  stati: { pending: { valore: '0', checked: '0', label: 'Attesa Ricambi', color: '#ff7040' }, processing: { valore: '1', checked: '0', label: 'In Riparazione', color: '#ffcd00' }, fixed: { valore: '2', checked: '1', label: 'Riparato', color: '#01c776' }, completed: { valore: '3', checked: '1', label: 'Consegnato', color: '#01c776' } },
  localDateTime : ''
}

// getters
const getters = {
  stati: state => state.stati,
  setPriceOf: state => state.setPriceOf,
  orderObj: state => state.orderObj,
  infoDispositivoIndex: state => state.infoDispositivoIndex,
  checkOutMode: state => state.checkOutMode,
  showModal: state => state.showModal,
  selettore: state => state.selettore,
  cart: state => state.cart,
  orderState: state => state.orderState,
  selectedDevice: state => state.selectedDevice,
  deviceList: state => state.deviceList,
  deviceDettails: (state, getters) => {
    if (getters.cart[getters.infoDispositivoIndex] !== undefined) return getters.cart[getters.infoDispositivoIndex].deviceDettails
    else return 'empty'
  },
  totalBill: (state, getters) => {
    if (getters.cart.length === 0) { return 0 } else {
      //  calcola il totale del carrello
      let risultato
      risultato = getters.cart.reduce(function (foo, bar) {
        if (!foo) {
          foo = 0
        }
        let tot = parseFloat(foo) + parseFloat(bar['parziale'])
        return tot.toFixed(2)
      }, '')
      return risultato
    }
  },
  totalProfit: (state, getters) => {
    if (getters.cart.length === 0) { return 0 } else {
      //  calcola il totale del carrello
      let risultato
      risultato = getters.cart.reduce(function (foo, bar) {
        if (!foo) {
          foo = 0
        }
        let tot = parseFloat(foo) + parseFloat(bar['utile'])
        return tot.toFixed(2)
      }, '')
      return risultato
    }
  },
  statoOrdine: (state, getters) => {
    //RESTITUISCE LO STATO CON VALORE PIU BASSO DELLE RIPARAZIONI PRESENTI IN CART
    if (getters.cart.length === 0) { return null } else {
      let risultato = getters.cart.reduce(function (foo, bar) {
        if (!foo && bar.type === "repair") {
          return bar.state
        }
        if ((parseFloat(state.stati[bar.state].valore) < parseFloat(state.stati[foo].valore)) && bar.type === 'repair') { return bar.state } else { return foo }
      }, '')
      if (state.orderObj.checkout !== undefined) { return 'completed' } else {
        return risultato
      }
    }
  }
}

// actions
const actions = {
  updatePriceInDB({ commit, state, getters, dispatch }, payload) {
    var obj = payload.obj
    var price = payload.price
    var pointer = 'Utenti/' + this.state.loginStates.userDettails.uid + '/' + 'ricambi' + '/' + obj + '/' + 'prezzo'
    this.databaseOps.db.ref(pointer).set(price, function (error) {
      if (error) console.log('Errore caricamenti ricambio')
      else {
        console.log('ricambio aggiunto al nodo interno')
        // self.uploadImmagine(self.ricambio.id,self.immagini[0])
      }
    })
  },
  cloneToNodoInterno({ commit, state, getters, dispatch }, payload) {
    var obj = payload
    console.log('Rilevato ricambio fonte esterna ')
    // var key_ricambio = ref['ricambi'].push().key;
    //  QUESITO : l' id del ricambio proveniente dal nodo esterno deve rimanere tale nell' interno?
    obj.fonte = 'interno'
    obj.img_name = obj.id + '.ext'
    // sistemare regola firebase che previene sovrascrittura intero nodo ricambi
    var pointer = 'Utenti/' + this.state.loginStates.userDettails.uid + '/' + 'ricambi'
    this.databaseOps.db.ref(pointer).child(obj.id).set(obj, function (error) {
      if (error) console.log('Errore caricamenti ricambio')
      else {
        console.log('ricambio aggiunto al nodo interno')
        // self.uploadImmagine(self.ricambio.id,self.immagini[0])
      }
    })
  },
  addToCart({ commit, state, getters, dispatch }, payload) {
    var obj = payload
    //var selectedDevice = state.cart.length - 1
    //SE IL DISPOSITIVO E' STATO SALVATO SENZA RICAMBI CREO L'ARRAY RICAMBI
    if (state.cart[state.selectedDevice].ricambi === undefined) {
      Vue.set(state.cart[state.selectedDevice], 'ricambi', [])
    }
    const mapIds = state.cart[state.selectedDevice].ricambi.map(foo => foo['id'])
    if (!mapIds.includes(obj.id)) {
      state.cart[state.selectedDevice].ricambi.push(obj)
    }
  },
  addRiparazione({ commit, state, getters, dispatch }, payload) {
    var obj = payload
    var repair = {
      id: obj.id,
      dispositivo: obj.value,
      percorso_ricambi: {
        hook: obj.parent,
        id: obj.id,
        value: obj.value
      },
      parent: obj.parent,
      fonte: obj.fonte,
      img_name: obj.id,
      parziale: '',
      parziale_senza_sconto: '',
      deviceDettails: {},
      ricambi: [],
      costo: '0.00',
      sconto: '0.00',
      utile: '0.00',
      state: 'processing',  //IN RIPARAZIONE
      type: 'repair'
    }
    // aggiungo placeholder creato alla riparzione.
    state.cart.push(repair)
    state.selectedDevice = state.cart.length - 1
  },
  addToCartRequest({ commit, state, getters, dispatch }, payload) {
    var obj = payload
    //SE E' UN DISPOSITIVO
    if (obj.parent === 'modelli') {
      // creo il placeholder della riparazione.
      dispatch("addRiparazione", obj);
    }
    if (obj.parent === 'ricambi' && !(obj.prezzo > 0)) {
      dispatch("showPriceSetter", obj);
      return
    }
    //QUESTO POTREBBE DIVENTARE addToCart
    // se si tratta di un ricambio lo aggiungo a carrello nel placeholder corretto.
    if (obj.parent === 'ricambi') {
      dispatch("addToCart", obj);
    }
  },
  showPriceSetter({ commit, state, getters }, payload) {
    state.setPriceOf = payload
  },
  setAllFixed({ commit, state, getters }, payload) {
    let n = state.cart.length
    let i
    for (i = 0; i <= (n - 1); i++) {
      if (state.cart[i].type === "repair") {
        commit('setRepairFixed', i)
      }
    }
  },
  setFixedInDB({ commit, state, getters }, payload) {
    var pointer = 'Utenti/' + this.state.loginStates.userDettails.uid + '/' + 'Ordini' + '/' + payload.keyOrder + '/'
    let aggiornamento = { "state": "fixed", "riparazioni/0/state": "fixed" }
    this.databaseOps.db.ref(pointer).update(aggiornamento, function (error) {
      if (error) console.log('Errore')
      else {
        console.log('aggiornato stato')
        // self.uploadImmagine(self.ricambio.id,self.immagini[0])
      }
    })
    //QUESTA FUNZIONE VIENE UTILIZZATA SOLO DAL TASTO
    //CHE PERMETTE DI SETTARE A "FIXED" LA RIPARAZIONE NEL CARRELLO
    //SOLO QUANDO E' UNA SOLA, INFATTI QUEL TASTO APPARIRA' SOLO
    //QUANDO CE' UNA SOLA RIPARAZIONE NEL CARRELLO E SARA' POSSIBILE
    //SPUNTARE LA RIPARAZIONE DIRETTAMENTE DA LI'
    //NEGLI ALTRI CASI APPARIRA' DIRETTAMENTE IL TASTO CHECK OUT
  },
  saveOrder({ commit, state, getters }, payload) {

    console.log('save order')
    commit('getLocalDateTime')
    var pointer = 'Utenti/' + this.state.loginStates.userDettails.uid
    var key = this.databaseOps.db.ref(pointer).push().key
    var paths = {}
    var stato = getters.statoOrdine
    var obj = Object.assign(
      state.orderObj,
      { id_cliente: _.get(state.orderObj, 'id_cliente', ''), cognome: _.get(state.orderObj, 'cognome', ''), telefono: _.get(state.orderObj, 'telefono', ''), id: key, timestamp: (new Date().getTime()), _timestamp: -(new Date().getTime()) },
      { totale: getters.totalBill },
      { utile: getters.totalProfit },
      // { dettagli_ord: this.dettagli_ord },
      { riparazioni: state.cart },
      { localDateTime: state.localDateTime },
      { state: stato },
      // { accessori: this.accessori_nel_carrello }

    )
    paths['Ordini/' + key] = obj
    // paths['ricambi/' + key] = obj 
    // this.databaseOps.db.ref(pointer).child(key).set(obj)
    // this.databaseOps.db.ref(pointer).update(paths)
    // Do a deep-path update
    this.databaseOps.db.ref(pointer).update(paths, function (error) {
      if (error) {
        console.log('Errore operazione atomica ordini:', error)
      }
    })
    router.replace('ordini')
  },
  updateOrder({ commit, state, getters }, payload) {
    console.log('update order')
    var paths = {}
    var pointer = 'Utenti/' + this.state.loginStates.userDettails.uid
    state.orderObj.riparazioni = state.cart
    var stato = getters.statoOrdine
    var obj = Object.assign(
      state.orderObj,
      { updatedTime: (new Date().getTime()), _updatedTime: -(new Date().getTime()) },
      { totale: getters.totalBill },
      { utile: getters.totalProfit },
      { state: stato },
      // { dettagli_ord: this.dettagli_ord },
      //  { riparazioni: state.cart }
      // { accessori: this.accessori_nel_carrello }
    )
    paths['Ordini/' + state.orderObj.id] = obj
    this.databaseOps.db.ref(pointer).update(paths, function (error) {
      if (error) {
        console.log('Errore operazione atomica ordini:', error)
      }
    })
    router.replace('ordini')
  },
  getOrder({ commit, state }, id) {
    commit('resetOrder')
    commit('setOrderState', 'existing')
    var pointer = 'Utenti/' + this.state.loginStates.userDettails.uid + '/' + 'Ordini'
    this.databaseOps.db.ref(pointer).child(id).on('child_added', function (snapshot) {
      var item = snapshot.val()
      commit('setOrderObj', { key: snapshot.key, value: item })
      if (snapshot.key === 'dettagli_ord') state.orderDettails = item
      if (snapshot.key === 'riparazioni') state.cart = item
      // if (snapshot.key === 'accessori') state.accessori_nel_carrello = item 
    })
  },
  makeCheckout({ commit, state, dispatch, getters }, payload) {
    //let stato = 'completed'
    // SETTO VARIABILI DELL OGGETTO ORDINE
    commit('getLocalDateTime')
    commit('setOrderObj', { key: 'paymentMethod', value: payload.paymentMethod })
    commit('setOrderObj', { key: 'checkout', value: {'timestamp' : Date.now(), 'bill' : getters.totalBill, 'localDateTime' : state.localDateTime } })
    //commit('setOrderObj', { key: 'state', value: stato })
    // SE ORDINE NUOVO SALVO SE ESISTENTE AGGIORNO
    if (state.orderState === 'new') {
      dispatch('saveOrder', payload)
    } else {
      dispatch('updateOrder', payload)
    }
  },
  removeDevice({ commit, state }, payload) {
    state.cart.splice(payload, 1)
    if (state.cart.length === 0) {
      state.selettore.resetSelettore = 'foo'
    } else {
      if (payload === state.selectedDevice) {
        commit('setSelectedDevice', state.cart.length - 1)
      } else if (payload < state.selectedDevice) {
        commit('setSelectedDevice', state.selectedDevice - 1)
      }
    }
  }
}
// se selettore si trova per esempio su iphone 6 e ho gia iphone 6 come dispositivo devo selezionarlo in automatico
// mutations
const mutations = {
  getLocalDateTime(state,payload){
    let data = new Date()
    let current = data.toString()
    //mi interessano solo i primi 24 caratteri il resto è la timezone
    //che non mi serve in quanto è una data assoluta
    state.localDateTime = current.substring(0,24)
  },
  setOrderObj(state, payload) {
    //SE VALORE UNDEFINED E IN ORDEROBJ ESISTE IL FIELD LO ELIMINO
    if (payload.value === undefined) {
      if (state.orderObj[payload.key]) Vue.delete(state.orderObj, payload.key);
    } else
      Vue.set(state.orderObj, payload.key, payload.value)
  },
  mostraInfo(state, payload) {
    state.infoDispositivoIndex = payload
  },
  setFormData(state, payload) {
    Vue.set(state[payload.state], payload.field, payload.value)
  },
  setArrayField(state, payload) {
    /* PAYLOAD EXAMPLE
   var payload = {
      arrayName: 'name',
      index: '2',
      field: '',
      value: 'ciao'
    } */
    Vue.set(state[payload.arrayName][payload.index], payload.field, payload.value)
  },
  setOrderState(state, value) {
    state.orderState = value
  },
  resetOrder(state, payload) {
    state.orderObj = {}
    state.cart = []
    state.orderDettails = ''
    state.appliedList = ''
    state.localListData = []
    state.deviceList = []
    state.selectedDevice = ''
    state.selectedTab = ''
  },
  setAsNew(state, payload) {
    state.orderState = 'new'
  },
  setState(state, payload) {
    console.log(payload)
    // state = stato da modificare , data = i dati che devo mettere nello stato da mod.
    state[payload.state] = payload.data
  },
  setSelectedDevice(state, value) {
    if (state.selectedDevice !== value) {
      state.selectedDevice = value
      var path = {
        hook: 'ricambi',
        id: state.cart[state.selectedDevice].id
      }
      state.selettore.posizioneSelettore = path
    }
  },
  setSelettorePosition(state, value) {
    state.selettore.posizioneSelettore = value
  },
  initSelettore(state, value) {
    state.selettore = value
  },
  setRepairFixed(state, payload) {
    let stato = 'fixed' //RIPARATO
    state.cart[payload].state = stato
  },
  setRepairProcessing(state, payload) {
    state.cart[payload].state = 'processing'
  },
  removeFromCart(state, payload) {
    console.log(payload)
    state.cart[payload.deviceIndex].ricambi.splice(payload.itemIndex, 1)
  },
  setDeviceDettails(state, payload) {
    var selectedDevice = state.infoDispositivoIndex
    state.cart[selectedDevice].deviceDettails = payload
  },
  enableCheckOutMode(state, payload) {
    state.checkOutMode = payload
    state.showModal = true
  },
  disableCheckOutMode(state, payload) {
    state.checkOutMode = false
    state.showModal = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
